import React, { useState } from 'react';
import { Modal as BaseModal, ModalHeader, ModalBody, ModalFooter, ModalButton } from "baseui/modal";
import '../styles.scss';
import { useJobActions } from '../../../../hooks/job.actions';

const VetsmithConfirmationModal = ({
    job,
    setVetsmithConfirmationModal,
}) => {
    const [loading, setLoading] = useState(false);
    const {
        autoSubmitUserJobInterest,
        isJobInterestFetching
    } = useJobActions()
    return (
        <BaseModal key="vetsmith-confirmation" onClose={() => setVetsmithConfirmationModal(false)} isOpen={true} closeable animate autoFocus>
            <ModalHeader>{job?.title || ""}</ModalHeader>
            <ModalBody>
                <p>
                    In order for you to complete your application for this job, you need to take a brief technical assessment to evaluate your technical fit for the role.
                </p>
            </ModalBody>
            <ModalFooter>
                <ModalButton
                    type="info"
                    className="vetsmith-confirmation-button"
                    isLoading={loading || isJobInterestFetching}
                    onClick={() => {
                        setLoading(true);
                        autoSubmitUserJobInterest(job);
                        // saveJobInterestInfoProps(
                        //     {
                        //         idHash: job.jobRequestCode,
                        //         isInterested: true,
                        //         availabilityConfirmed: true,
                        //         canOverlapWithTimezone: true,
                        //     },
                        //     `/dashboard/jobs/${job.id}/specialized-vetting`
                        // );
                    }}
                >
                    Continue
                </ModalButton>
            </ModalFooter>
        </BaseModal>
    )
}

export default VetsmithConfirmationModal;